import {RootState} from 'reducer';
import {clearAsset} from 'reducer/asset';
import {changeStatusScreen, clearAuthen} from 'reducer/authen';
import {clearTransaction} from 'reducer/transaction';
import {Middleware} from 'redux';

export const middlewareCatchApi: Middleware<
  {}, // Most middleware do not modify the dispatch return value
  RootState
> = storeApi => next => action => {
  if (
    action?.payload?.status == 401 &&
    action?.type != 'asset@/load/rejected'
  ) {
    storeApi.dispatch(changeStatusScreen('unAuthorized'));
    // return;
  }
  if (
    action?.type == 'authen@/doLogin/changeStatusScreen' &&
    action?.payload == 'unAuthorized'
  ) {
    storeApi.dispatch(clearAsset({}));
    storeApi.dispatch(clearTransaction({}));
    storeApi.dispatch(clearAuthen({}));
    // return;
  }
  return next(action);
};
